<div class="size-helper">
  <ig-page-header>
    <ng-template igHeadlineContent>
      <div class="p-grid">
        <div class="p-col-12 p-md-8">
          <h2 class="p-mb-2">{{ 'sdn' | translate }}</h2>
          <p [translate]="'mpls_intro'"></p>
        </div>
        <div class="p-col-12 p-md-4">
          <div class="ig-page-header__box">
            <div><strong>{{ 'sdn_help_headline' | translate }}</strong></div>
            <p [translate]="'sdn_help_text'"></p>
            <a [href]="currentLang === 'de' ? 'https://gridscale.io/community/tutorials/sdn-virtual-switch-1of2/' : 'https://gridscale.io/en/community/tutorials/sdn-virtual-switch-1of2e/'" target="_blank">Virtual Switches<i class="icon-a106_linkextern"></i></a>
            <span class="link-separator">|</span>
            <a [href]="currentLang === 'de' ? 'https://gridscale.io/community/tutorials/how-to-sdn-2-breakout/' : 'https://gridscale.io/en/community/tutorials/how-to-sdn-2-2-breakout/'" target="_blank">Breakouts<i class="icon-a106_linkextern"></i></a>
          </div>
        </div>
      </div>
    </ng-template>
  </ig-page-header>

  <div class="sub-view size-helper">

    <div class="relative">
      <div class="location-select-container p-d-flex p-ai-center p-jc-end">
        <span class="location-select-label">{{ 'select_location' | translate }}:&nbsp;&nbsp;</span>
        <form [formGroup]="locationSelectForm">
          <app-location-select-dropdown
            *ngIf="selectedLocation"
            (selectedLocationChange)="onUpdateSelectedLocation($event)"
            [selectedLocation]="selectedLocation"
            [withinEyecatcherNoLeftMargin]="true"
            appendTo="body"
            formControlName="default_location_uuid">
          </app-location-select-dropdown>
        </form>
      </div>


      <app-navigation-sub-menu-tabs parentNavigationLink="/Accounts/SDN"></app-navigation-sub-menu-tabs>
    </div>

    <div class="outletter">
      <router-outlet></router-outlet>
    </div>





  </div>

</div>
